import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "رشته", "گرایش", "توضیحات", "کمیسیون مشاوره", "ارزش افزوده مشاوره", "کمیسیون خدمات", "ارزش افزوده خدمات", "وضعیت", "عملیات"];

export function BranchCommissionGrid({
                                       BranchCommissions,
                                       setModalOpen,
                                       setSelectedRow,
                                     }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "توضیحات": "description",
    "کمیسیون مشاوره": "consultation_commission",
    "ارزش افزوده مشاوره": "consultation_vat_percentage",
    "کمیسیون خدمات": "service_commission",
    "ارزش افزوده خدمات": "service_vat_percentage",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "رشته": true,
    "گرایش": true,
    "توضیحات": true,
    "کمیسیون مشاوره": true,
    "ارزش افزوده مشاوره": true,
    "کمیسیون خدمات": true,
    "ارزش افزوده خدمات": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {BranchCommissions.map(
          ({
             id,
             field_title,
             branch_title,
             description,
             consultation_commission,
             consultation_vat_percentage,
             service_commission,
             service_vat_percentage,
             status,
             branch_id
           }, index) => {
            const isLast = index === BranchCommissions.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={branch_id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {consultation_commission && persianNumberFormat(consultation_commission) + "%"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {consultation_vat_percentage && persianNumberFormat(consultation_vat_percentage) + "%"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {service_commission && persianNumberFormat(service_commission) + "%"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {service_vat_percentage && persianNumberFormat(service_vat_percentage) + "%"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="عملیات">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(BranchCommissions[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}